<div style="padding: 20px; text-align: center;">
    <h3>Redirigiendo al registro...</h3>
    <p>El sistema de activación ahora utiliza códigos de activación. Serás redirigido al formulario de registro.</p>
</div>